export const buyerClientContext = {
  problems: '/review-service/api/external/buyers/{id}/problems',
};
